import { PageConfig } from '../pageConfigTs';

export const PAGE_CONFIG: PageConfig = {
  title: 'Revenue',
  titleCN: '付费流水',
  subTitle: '',
  subTitleCN: '',
  path: '/monetization/revenue',
  defaultTab: 'inGameRevenue',
  tabList: [
    {
      id: 'inGameRevenue',
      tabName: 'In-Game Revenue',
      tabNameCN: '游戏内收入',
      isHaveNotification: true,
      notificationPath: '/monetization/revenue/inGameRevenue',
      path: '/monetization/revenue/inGameRevenue',
      logConfig: {
        pageId: '202903',
        pageName: 'inGameRevenue',
        extInfo: 'inGameRevenue',
        pagePath: '/monetization/revenue/inGameRevenue'
      },
      filters: [
        {
          name: 'PcConsoleRevenueInGameFilter',
          isOpenSticky: true,
          isHaveFilterSave: true,
          filterPath: '/monetization/revenue/inGameRevenue',
          componentList: [
            {
              name: 'PcConsoleMonetizationRevenueTrendCo',
              className: '',
              type: 'view',
              style: {},
              props: {
                config: {
                  api: '/api/v1/dashboard/pc/monetization/revenue/ingame/trends',
                  dataKey: 'PcMonetizationRevenueData'
                }
              },
              children: [
                {
                  name: 'CommonRow',
                  className: '',
                  type: 'layout',
                  style: {},
                  props: {},
                  children: [
                    {
                      name: 'CommonCol',
                      className: 'margin-t-20',
                      type: 'layout',
                      style: {},
                      props: {
                        w: 12
                      },
                      children: [
                        {
                          name: 'PCRevenueCo',
                          className: '',
                          style: {},
                          enName: 'In-Game Revenue($)',
                          cnName: '内购收入($)',
                          defaultActive: 1,
                          type: 'view',
                          props: {
                            config: {
                              chart: {
                                type: 'decimals',
                                isPercent: false,
                                decimal: 2
                              },
                              componentMetricsConfig: [
                                {
                                  metricKey: 'mtx_revenue',
                                  enName: 'In-Game Revenue($)',
                                  cnName: '内购收入($)',
                                  isPercent: false,
                                  decimal: 2,
                                  type: 'decimals'
                                }
                              ]
                            }
                          },
                          children: []
                        }
                      ]
                    },
                    {
                      name: 'CommonCol',
                      className: 'margin-t-20',
                      type: 'layout',
                      style: {},
                      props: {
                        w: 12
                      },
                      children: [
                        {
                          name: 'PcRevenueChannelDistributionCo',
                          className: '',
                          enName: '',
                          cnName: '',
                          defaultActive: 2,
                          style: {},
                          type: 'view',
                          props: {
                            config: {}
                          },
                          children: []
                        }
                      ]
                    }
                  ]
                },
                {
                  name: 'CommonRow',
                  className: 'margin-b-10 margin-t-10',
                  type: 'layout',
                  style: {},
                  props: {},
                  children: [
                    {
                      name: 'CommonCol',
                      className: '',
                      type: 'layout',
                      style: {},
                      props: {
                        w: 12
                      },
                      children: [
                        {
                          name: 'PcPayerAndPayerCo',
                          className: '',
                          style: {},
                          enName: 'In-Game Payer and Payer%',
                          cnName: '内购付费人数和内购付费渗透率',
                          type: 'view',
                          props: {
                            config: {
                              componentMetricsConfig: [
                                {
                                  metricKey: 'mtx_payers',
                                  enName: 'In-Game Payer',
                                  cnName: '内购付费人数',
                                  isPercent: false,
                                  decimal: 2,
                                  type: 'decimals'
                                },
                                {
                                  metricKey: 'mtx_payer_rate',
                                  enName: 'In-Game Payer%',
                                  cnName: '内购付费渗透率',
                                  isPercent: true,
                                  decimal: 2,
                                  type: 'percent'
                                }
                              ]
                            }
                          },
                          children: []
                        }
                      ]
                    },
                    {
                      name: 'CommonCol',
                      className: '',
                      type: 'layout',
                      style: {},
                      props: {
                        w: 12
                      },
                      children: [
                        {
                          name: 'PcRevenueMetricsTrendsCo',
                          className: '',
                          enName: 'In-Game ARPU & ARPPU',
                          cnName: '内购ARPU & 内购付费ARPPU',
                          defaultActive: 2,
                          style: {},
                          type: 'view',
                          props: {
                            config: {
                              chart: {
                                type: 'decimals',
                                isPercent: false,
                                decimal: 2
                              },
                              componentMetricsConfig: [
                                {
                                  metricKey: 'mtx_arpu',
                                  enName: 'In-Game ARPU($)',
                                  cnName: '内购ARPU($)',
                                  isPercent: false,
                                  decimal: 2,
                                  type: 'decimals'
                                },
                                {
                                  metricKey: 'mtx_arppu',
                                  enName: 'In-Game ARPPU($)',
                                  cnName: '内购付费ARPPU($)',
                                  isPercent: false,
                                  decimal: 2,
                                  type: 'decimals'
                                }
                              ]
                            }
                          },
                          children: []
                        }
                      ]
                    }
                  ]
                },
                {
                  name: 'OverallTableCo',
                  className: 'margin-t-20',
                  type: 'view',
                  style: {},
                  props: {
                    config: {
                      isHaveDiff: false,
                      showStatistic: ['sum', 'avg_no_null'],
                      slotConfig: {
                        isShowdownloadConfig: true,
                        isShowProgressBar: false
                      },
                      isHavePageDefaultSelector: true,
                      valueTypeConfig: {
                        valueType: 'value_only',
                        isShowChange: false
                      },
                      dimensionConfig: {
                        defaultAccumulation: ['date'],
                        isShowCountryFlag: true,
                        dateDisable: true
                      },
                      api: {
                        tableApi: '/api/v1/dashboard/pc/monetization/revenue/ingame/overall_performance',
                        tableDownloadApi: '/api/v1/dashboard/pc/monetization/revenue/ingame/overall_performance/download'
                      },
                      titleEn: 'Overall Payment',
                      titleCn: '总体付费表现',
                      componentMetricsConfig: {
                        Day: [
                          {
                            metricKey: 'total_mtx_revenue',
                            reqMetricKey: 'total_mtx_revenue',
                            cnWidth: 150,
                            enWidth: 310,
                            cnPercentWidth: 200,
                            enPercentWidth: 310,
                            resAvgName: '',
                            rainbowKey: 'Accumulate MTX Rev',
                            enName: 'Accumulate In-Game Rev($)',
                            cnName: '累计内购收入($)',
                            avgName: '',
                            isPercent: false,
                            decimal: 2,
                            isUserType: false,
                            type: 'decimals',
                            percentDecimals: 1,
                            percentDecimalsFloating: true
                          },
                          {
                            metricKey: 'total_mtx_payers',
                            reqMetricKey: 'total_mtx_payers',
                            cnWidth: 160,
                            enWidth: 270,
                            cnPercentWidth: 200,
                            enPercentWidth: 300,
                            resAvgName: '',
                            rainbowKey: 'Accumulate MTX Payer',
                            cnName: '累计内购付费用户数',
                            enName: 'Accumulate In-Game Payer',
                            avgName: '',
                            isPercent: false,
                            decimal: 2,
                            isUserType: true,
                            type: 'int',
                            percentDecimals: 1,
                            percentDecimalsFloating: true
                          },
                          {
                            metricKey: 'total_mtx_payer_rate',
                            reqMetricKey: 'total_mtx_payer_rate',
                            cnWidth: 160,
                            enWidth: 300,
                            cnPercentWidth: 200,
                            enPercentWidth: 300,
                            resAvgName: '',
                            rainbowKey: 'Accumulate MTX Payer%',
                            enName: 'Accumulate In-Game Payer%',
                            cnName: '累计内购付费渗透率',
                            avgName: '',
                            isPercent: true,
                            decimal: 1,
                            isUserType: false,
                            type: 'percent',
                            percentDecimals: 1,
                            percentDecimalsFloating: true
                          },
                          {
                            metricKey: 'mtx_revenue',
                            reqMetricKey: 'mtx_revenue',
                            resAvgName: '',
                            rainbowKey: 'Pc In-Game Revenue',
                            cnWidth: 160,
                            enWidth: 200,
                            cnPercentWidth: 160,
                            enPercentWidth: 200,
                            enName: 'In-Game Revenue',
                            cnName: '内购收入',
                            type: 'decimals',
                            avgName: '',
                            isPercent: false,
                            decimals: 1,
                            isUserType: false,
                            percentDecimals: 1,
                            percentDecimalsFloating: true
                          },
                          {
                            metricKey: 'active_users',
                            reqMetricKey: 'active_users',
                            cnWidth: 140,
                            enWidth: 140,
                            cnPercentWidth: 160,
                            enPercentWidth: 160,
                            resAvgName: '',
                            enName: 'DAU',
                            cnName: '日活跃',
                            rainbowKey: 'DAU',
                            type: 'int',
                            avgName: '',
                            isPercent: false,
                            decimals: 1,
                            isUserType: true,
                            percentDecimals: 1,
                            percentDecimalsFloating: true
                          },
                          {
                            metricKey: 'mtx_arpu',
                            reqMetricKey: 'mtx_arpu',
                            cnWidth: 160,
                            enWidth: 200,
                            cnPercentWidth: 160,
                            enPercentWidth: 200,
                            resAvgName: '',
                            rainbowKey: 'Pc In-Game ARPU',
                            enName: 'In-Game ARPU',
                            cnName: '内购ARPU',
                            avgName: '',
                            isPercent: false,
                            decimals: 1,
                            type: 'decimals',
                            isUserType: false,
                            percentDecimals: 1,
                            percentDecimalsFloating: true
                          },
                          {
                            metricKey: 'mtx_arppu',
                            reqMetricKey: 'mtx_arppu',
                            cnWidth: 160,
                            enWidth: 200,
                            cnPercentWidth: 160,
                            enPercentWidth: 200,
                            resAvgName: '',
                            rainbowKey: 'Pc In-Game ARPPU',
                            enName: 'In-Game ARPPU',
                            cnName: '内购付费ARPPU',
                            type: 'decimals',
                            avgName: '',
                            isPercent: false,
                            decimals: 1,
                            isUserType: false,
                            percentDecimals: 1,
                            percentDecimalsFloating: true
                          },
                          {
                            metricKey: 'mtx_payers',
                            reqMetricKey: 'mtx_payers',
                            cnWidth: 160,
                            enWidth: 200,
                            cnPercentWidth: 160,
                            enPercentWidth: 200,
                            resAvgName: '',
                            rainbowKey: 'Pc In-Game Payer',
                            enName: 'In-Game Payer',
                            cnName: '内购付费人数',
                            type: 'int',
                            avgName: '',
                            isPercent: false,
                            decimals: 1,
                            isUserType: true,
                            percentDecimals: 1,
                            percentDecimalsFloating: true
                          },
                          {
                            metricKey: 'mtx_payer_rate',
                            reqMetricKey: 'mtx_payer_rate',
                            cnWidth: 160,
                            enWidth: 200,
                            cnPercentWidth: 160,
                            enPercentWidth: 200,
                            resAvgName: '',
                            rainbowKey: 'Pc In-Game Payer%',
                            enName: 'In-Game Payer%',
                            cnName: '内购付费渗透率',
                            avgName: '',
                            isPercent: true,
                            decimal: 1,
                            isUserType: false,
                            type: 'percent',
                            percentDecimals: 1,
                            percentDecimalsFloating: true
                          },
                          {
                            metricKey: 'new_user_mtx_payer_rate',
                            reqMetricKey: 'new_user_mtx_payer_rate',
                            cnWidth: 245,
                            enWidth: 300,
                            cnPercentWidth: 270,
                            enPercentWidth: 330,
                            resAvgName: '',
                            rainbowKey: 'MTX Payer%(New Users)',
                            enName: 'In-Game Payer%(New Users)',
                            cnName: '内购付费渗透率（新进用户）',
                            avgName: '',
                            isPercent: true,
                            decimal: 1,
                            isUserType: false,
                            type: 'percent',
                            percentDecimals: 1,
                            percentDecimalsFloating: true
                          },
                          {
                            metricKey: 'mtx_new_paid_users',
                            reqMetricKey: 'mtx_new_paid_users',
                            cnWidth: 160,
                            enWidth: 280,
                            cnPercentWidth: 200,
                            enPercentWidth: 280,
                            resAvgName: '',
                            rainbowKey: 'First-time MTX Payer',
                            enName: 'First-time In-Game Payer',
                            cnName: '首次内购用户',
                            type: 'int',
                            avgName: '',
                            isPercent: false,
                            decimals: 1,
                            isUserType: true,
                            percentDecimals: 1,
                            percentDecimalsFloating: true
                          },
                          {
                            metricKey: 'mtx_new_pay_amount',
                            reqMetricKey: 'mtx_new_pay_amount',
                            cnWidth: 170,
                            enWidth: 320,
                            cnPercentWidth: 220,
                            enPercentWidth: 320,
                            resAvgName: '',
                            rainbowKey: 'Rev(First-time MTX Payer)',
                            enName: 'Rev(First-time In-Game Payer)($)',
                            cnName: '首次内购收入($)',
                            type: 'decimals',
                            avgName: '',
                            isPercent: false,
                            decimals: 2,
                            isUserType: false,
                            percentDecimals: 1,
                            percentDecimalsFloating: true
                          },
                          {
                            metricKey: 'mtx_new_arpu',
                            reqMetricKey: 'mtx_new_arpu',
                            cnWidth: 230,
                            enWidth: 340,
                            cnPercentWidth: 260,
                            enPercentWidth: 340,
                            resAvgName: '',
                            rainbowKey: 'First-time MTX Payer ARPU',
                            enName: 'First-time In-Game Payer ARPU($)',
                            cnName: '首次内购用户ARPU($)',
                            type: 'decimals',
                            avgName: '',
                            isPercent: false,
                            decimals: 2,
                            isUserType: false,
                            percentDecimals: 1,
                            percentDecimalsFloating: true
                          },
                          {
                            metricKey: 'new_user_arpu',
                            reqMetricKey: 'new_user_arpu',
                            cnWidth: 210,
                            enWidth: 180,
                            cnPercentWidth: 260,
                            enPercentWidth: 210,
                            resAvgName: '',
                            rainbowKey: 'New User ARPU',
                            enName: 'New User ARPU($)',
                            cnName: '新进用户付费ARPU($)',
                            type: 'decimals',
                            avgName: '',
                            isPercent: false,
                            decimals: 2,
                            isUserType: false,
                            percentDecimals: 1,
                            percentDecimalsFloating: true
                          },
                          {
                            metricKey: 'total_pay_days',
                            reqMetricKey: 'total_pay_days',
                            cnWidth: 210,
                            enWidth: 160,
                            cnPercentWidth: 230,
                            enPercentWidth: 200,
                            resAvgName: '',
                            rainbowKey: 'Total Pay Days',
                            enName: 'Total Pay Days',
                            cnName: '所有用户累计付费天数',
                            type: 'int',
                            avgName: '',
                            isPercent: false,
                            decimals: 1,
                            isUserType: true,
                            percentDecimals: 1,
                            percentDecimalsFloating: true
                          },
                          {
                            metricKey: '30d_ltv',
                            reqMetricKey: '30d_ltv',
                            cnWidth: 140,
                            enWidth: 200,
                            cnPercentWidth: 200,
                            enPercentWidth: 200,
                            resAvgName: '',
                            rainbowKey: 'MTX LTV30',
                            enName: 'In-Game LTV30',
                            cnName: '30天内购LTV',
                            type: 'int',
                            avgName: '',
                            isPercent: false,
                            decimals: 1,
                            isUserType: false,
                            percentDecimals: 1,
                            percentDecimalsFloating: true
                          },
                          {
                            metricKey: '180d_ltv',
                            reqMetricKey: '180d_ltv',
                            cnWidth: 140,
                            enWidth: 200,
                            cnPercentWidth: 200,
                            enPercentWidth: 200,
                            resAvgName: '',
                            rainbowKey: 'MTX LTV180',
                            enName: 'In-Game LTV180',
                            cnName: '180天内购LTV',
                            type: 'int',
                            avgName: '',
                            isPercent: false,
                            decimals: 1,
                            isUserType: false,
                            percentDecimals: 1,
                            percentDecimalsFloating: true
                          },
                          {
                            metricKey: 'avg_time_to_purchase',
                            reqMetricKey: 'avg_time_to_purchase',
                            cnWidth: 190,
                            enWidth: 220,
                            cnPercentWidth: 230,
                            enPercentWidth: 250,
                            resAvgName: '',
                            rainbowKey: 'Time to Purchase (days)',
                            enName: 'Time to Purchase (days)',
                            cnName: '购买时间间隔(天)',
                            type: 'decimals',
                            avgName: '',
                            isPercent: false,
                            decimals: 1,
                            isUserType: false,
                            percentDecimals: 1,
                            percentDecimalsFloating: true
                          }
                        ],
                        Week: [
                          {
                            metricKey: 'total_mtx_revenue',
                            reqMetricKey: 'total_mtx_revenue',
                            cnWidth: 150,
                            enWidth: 310,
                            cnPercentWidth: 200,
                            enPercentWidth: 310,
                            resAvgName: '',
                            rainbowKey: 'Accumulate MTX Rev',
                            enName: 'Accumulate In-Game Rev($)',
                            cnName: '累计内购收入($)',
                            avgName: '',
                            isPercent: false,
                            decimal: 2,
                            isUserType: false,
                            type: 'decimals',
                            percentDecimals: 1,
                            percentDecimalsFloating: true
                          },
                          {
                            metricKey: 'total_mtx_payers',
                            reqMetricKey: 'total_mtx_payers',
                            cnWidth: 160,
                            enWidth: 270,
                            cnPercentWidth: 200,
                            enPercentWidth: 300,
                            resAvgName: '',
                            rainbowKey: 'Accumulate MTX Payer',
                            cnName: '累计内购付费用户数',
                            enName: 'Accumulate In-Game Rev',
                            avgName: '',
                            isPercent: false,
                            decimal: 2,
                            isUserType: true,
                            type: 'int',
                            percentDecimals: 1,
                            percentDecimalsFloating: true
                          },
                          {
                            metricKey: 'total_mtx_payer_rate',
                            reqMetricKey: 'total_mtx_payer_rate',
                            cnWidth: 160,
                            enWidth: 300,
                            cnPercentWidth: 200,
                            enPercentWidth: 300,
                            resAvgName: '',
                            rainbowKey: 'Accumulate MTX Payer%',
                            enName: 'Accumulate In-Game Payer%',
                            cnName: '累计内购付费渗透率',
                            avgName: '',
                            isPercent: true,
                            decimal: 1,
                            isUserType: false,
                            type: 'percent',
                            percentDecimals: 1,
                            percentDecimalsFloating: true
                          },
                          {
                            metricKey: 'mtx_revenue',
                            reqMetricKey: 'mtx_revenue',
                            resAvgName: '',
                            rainbowKey: 'Pc In-Game Revenue',
                            cnWidth: 160,
                            enWidth: 200,
                            cnPercentWidth: 160,
                            enPercentWidth: 200,
                            enName: 'In-Game Revenue',
                            cnName: '内购收入',
                            type: 'decimals',
                            avgName: '',
                            isPercent: false,
                            decimals: 1,
                            isUserType: false,
                            percentDecimals: 1,
                            percentDecimalsFloating: true
                          },
                          {
                            metricKey: 'active_users',
                            reqMetricKey: 'active_users',
                            cnWidth: 140,
                            enWidth: 140,
                            cnPercentWidth: 160,
                            enPercentWidth: 160,
                            resAvgName: '',
                            enName: 'WAU',
                            cnName: '周活跃',
                            rainbowKey: 'WAU',
                            type: 'int',
                            avgName: '',
                            isPercent: false,
                            decimals: 1,
                            isUserType: true,
                            percentDecimals: 1,
                            percentDecimalsFloating: true
                          },
                          {
                            metricKey: 'mtx_arpu',
                            reqMetricKey: 'mtx_arpu',
                            cnWidth: 160,
                            enWidth: 200,
                            cnPercentWidth: 160,
                            enPercentWidth: 200,
                            resAvgName: '',
                            rainbowKey: 'Pc In-Game ARPU',
                            enName: 'In-Game ARPU',
                            cnName: '内购ARPU',
                            avgName: '',
                            isPercent: false,
                            decimals: 1,
                            type: 'decimals',
                            isUserType: false,
                            percentDecimals: 1,
                            percentDecimalsFloating: true
                          },
                          {
                            metricKey: 'mtx_arppu',
                            reqMetricKey: 'mtx_arppu',
                            cnWidth: 160,
                            enWidth: 200,
                            cnPercentWidth: 160,
                            enPercentWidth: 200,
                            resAvgName: '',
                            rainbowKey: 'Pc In-Game ARPPU',
                            enName: 'In-Game ARPPU',
                            cnName: '内购付费ARPPU',
                            type: 'decimals',
                            avgName: '',
                            isPercent: false,
                            decimals: 1,
                            isUserType: false,
                            percentDecimals: 1,
                            percentDecimalsFloating: true
                          },
                          {
                            metricKey: 'mtx_payers',
                            reqMetricKey: 'mtx_payers',
                            cnWidth: 160,
                            enWidth: 200,
                            cnPercentWidth: 160,
                            enPercentWidth: 200,
                            resAvgName: '',
                            rainbowKey: 'Pc In-Game Payer',
                            enName: 'In-Game Payer',
                            cnName: '内购付费人数',
                            type: 'int',
                            avgName: '',
                            isPercent: false,
                            decimals: 1,
                            isUserType: true,
                            percentDecimals: 1,
                            percentDecimalsFloating: true
                          },
                          {
                            metricKey: 'mtx_payer_rate',
                            reqMetricKey: 'mtx_payer_rate',
                            cnWidth: 160,
                            enWidth: 200,
                            cnPercentWidth: 160,
                            enPercentWidth: 200,
                            resAvgName: '',
                            rainbowKey: 'Pc In-Game Payer%',
                            enName: 'In-Game Payer%',
                            cnName: '内购付费渗透率',
                            avgName: '',
                            isPercent: true,
                            decimal: 1,
                            isUserType: false,
                            type: 'percent',
                            percentDecimals: 1,
                            percentDecimalsFloating: true
                          },
                          {
                            metricKey: 'new_user_mtx_payer_rate',
                            reqMetricKey: 'new_user_mtx_payer_rate',
                            cnWidth: 245,
                            enWidth: 300,
                            cnPercentWidth: 160,
                            enPercentWidth: 330,
                            resAvgName: '',
                            rainbowKey: 'MTX Payer%(New Users)',
                            enName: 'In-Game Payer%(New Users)',
                            cnName: '内购付费渗透率（新进用户）',
                            avgName: '',
                            isPercent: true,
                            decimal: 1,
                            isUserType: false,
                            type: 'percent',
                            percentDecimals: 1,
                            percentDecimalsFloating: true
                          },
                          {
                            metricKey: 'mtx_new_paid_users',
                            reqMetricKey: 'mtx_new_paid_users',
                            cnWidth: 160,
                            enWidth: 280,
                            cnPercentWidth: 200,
                            enPercentWidth: 280,
                            resAvgName: '',
                            rainbowKey: 'First-time MTX Payer',
                            enName: 'First-time In-Game Payer',
                            cnName: '首次内购用户',
                            type: 'int',
                            avgName: '',
                            isPercent: false,
                            decimals: 1,
                            isUserType: true,
                            percentDecimals: 1,
                            percentDecimalsFloating: true
                          },
                          {
                            metricKey: 'mtx_new_pay_amount',
                            reqMetricKey: 'mtx_new_pay_amount',
                            cnWidth: 170,
                            enWidth: 320,
                            cnPercentWidth: 220,
                            enPercentWidth: 320,
                            resAvgName: '',
                            rainbowKey: 'Rev(First-time MTX Payer)($)',
                            enName: 'Rev(First-time In-Game Payer)($)',
                            cnName: '首次内购收入($)',
                            type: 'decimals',
                            avgName: '',
                            isPercent: false,
                            decimals: 2,
                            isUserType: false,
                            percentDecimals: 1,
                            percentDecimalsFloating: true
                          },
                          {
                            metricKey: 'mtx_new_arpu',
                            reqMetricKey: 'mtx_new_arpu',
                            cnWidth: 230,
                            enWidth: 340,
                            cnPercentWidth: 260,
                            enPercentWidth: 340,
                            resAvgName: '',
                            rainbowKey: 'First-time MTX Payer ARPU',
                            enName: 'First-time In-Game Payer ARPU($)',
                            cnName: '首次内购用户ARPU($)',
                            type: 'decimals',
                            avgName: '',
                            isPercent: false,
                            decimals: 2,
                            isUserType: false,
                            percentDecimals: 1,
                            percentDecimalsFloating: true
                          },
                          {
                            metricKey: 'new_user_arpu',
                            reqMetricKey: 'new_user_arpu',
                            cnWidth: 210,
                            enWidth: 180,
                            cnPercentWidth: 260,
                            enPercentWidth: 210,
                            resAvgName: '',
                            rainbowKey: 'New User ARPU($)',
                            enName: 'New User ARPU($)',
                            cnName: '新进用户付费ARPU($)',
                            type: 'decimals',
                            avgName: '',
                            isPercent: false,
                            decimals: 2,
                            isUserType: false,
                            percentDecimals: 1,
                            percentDecimalsFloating: true
                          }
                        ],
                        Month: [
                          {
                            metricKey: 'total_mtx_revenue',
                            reqMetricKey: 'total_mtx_revenue',
                            cnWidth: 150,
                            enWidth: 310,
                            cnPercentWidth: 200,
                            enPercentWidth: 310,
                            resAvgName: '',
                            rainbowKey: 'Accumulate MTX Rev',
                            enName: 'Accumulate In-Game Rev($)',
                            cnName: '累计内购收入($)',
                            avgName: '',
                            isPercent: false,
                            decimal: 2,
                            isUserType: false,
                            type: 'decimals',
                            percentDecimals: 1,
                            percentDecimalsFloating: true
                          },
                          {
                            metricKey: 'total_mtx_payers',
                            reqMetricKey: 'total_mtx_payers',
                            cnWidth: 160,
                            enWidth: 270,
                            cnPercentWidth: 200,
                            enPercentWidth: 300,
                            resAvgName: '',
                            rainbowKey: 'Accumulate MTX Payer',
                            cnName: '累计内购付费用户数',
                            enName: 'Accumulate In-Game Rev',
                            avgName: '',
                            isPercent: false,
                            decimal: 2,
                            isUserType: true,
                            type: 'int',
                            percentDecimals: 1,
                            percentDecimalsFloating: true
                          },
                          {
                            metricKey: 'total_mtx_payer_rate',
                            reqMetricKey: 'total_mtx_payer_rate',
                            cnWidth: 160,
                            enWidth: 300,
                            cnPercentWidth: 200,
                            enPercentWidth: 300,
                            resAvgName: '',
                            rainbowKey: 'Accumulate MTX Payer%',
                            enName: 'Accumulate In-Game Payer%',
                            cnName: '累计内购付费渗透率',
                            avgName: '',
                            isPercent: true,
                            decimal: 1,
                            isUserType: false,
                            type: 'percent',
                            percentDecimals: 1,
                            percentDecimalsFloating: true
                          },
                          {
                            metricKey: 'mtx_revenue',
                            reqMetricKey: 'mtx_revenue',
                            resAvgName: '',
                            rainbowKey: 'Pc In-Game Revenue',
                            cnWidth: 160,
                            enWidth: 200,
                            cnPercentWidth: 160,
                            enPercentWidth: 200,
                            enName: 'In-Game Revenue',
                            cnName: '内购收入',
                            type: 'decimals',
                            avgName: '',
                            isPercent: false,
                            decimals: 1,
                            isUserType: false,
                            percentDecimals: 1,
                            percentDecimalsFloating: true
                          },
                          {
                            metricKey: 'active_users',
                            reqMetricKey: 'active_users',
                            cnWidth: 140,
                            enWidth: 140,
                            cnPercentWidth: 160,
                            enPercentWidth: 160,
                            resAvgName: '',
                            enName: 'MAU',
                            cnName: '月活跃',
                            rainbowKey: 'MAU',
                            type: 'int',
                            avgName: '',
                            isPercent: false,
                            decimals: 1,
                            isUserType: true,
                            percentDecimals: 1,
                            percentDecimalsFloating: true
                          },
                          {
                            metricKey: 'mtx_arpu',
                            reqMetricKey: 'mtx_arpu',
                            cnWidth: 160,
                            enWidth: 200,
                            cnPercentWidth: 160,
                            enPercentWidth: 200,
                            resAvgName: '',
                            rainbowKey: 'Pc In-Game ARPU',
                            enName: 'In-Game ARPU',
                            cnName: '内购ARPU',
                            avgName: '',
                            isPercent: false,
                            decimals: 1,
                            type: 'decimals',
                            isUserType: false,
                            percentDecimals: 1,
                            percentDecimalsFloating: true
                          },
                          {
                            metricKey: 'mtx_arppu',
                            reqMetricKey: 'mtx_arppu',
                            cnWidth: 160,
                            enWidth: 200,
                            cnPercentWidth: 160,
                            enPercentWidth: 200,
                            resAvgName: '',
                            rainbowKey: 'Pc In-Game ARPPU',
                            enName: 'In-Game ARPPU',
                            cnName: '内购付费ARPPU',
                            type: 'decimals',
                            avgName: '',
                            isPercent: false,
                            decimals: 1,
                            isUserType: false,
                            percentDecimals: 1,
                            percentDecimalsFloating: true
                          },
                          {
                            metricKey: 'mtx_payers',
                            reqMetricKey: 'mtx_payers',
                            cnWidth: 160,
                            enWidth: 200,
                            cnPercentWidth: 200,
                            enPercentWidth: 200,
                            resAvgName: '',
                            rainbowKey: 'Pc In-Game Payer',
                            enName: 'In-Game Payer',
                            cnName: '内购付费人数',
                            type: 'int',
                            avgName: '',
                            isPercent: false,
                            decimals: 1,
                            isUserType: true,
                            percentDecimals: 1,
                            percentDecimalsFloating: true
                          },
                          {
                            metricKey: 'mtx_payer_rate',
                            reqMetricKey: 'mtx_payer_rate',
                            cnWidth: 160,
                            enWidth: 200,
                            cnPercentWidth: 160,
                            enPercentWidth: 200,
                            resAvgName: '',
                            rainbowKey: 'Pc In-Game Payer%',
                            enName: 'In-Game Payer%',
                            cnName: '内购付费渗透率',
                            avgName: '',
                            isPercent: true,
                            decimal: 1,
                            isUserType: false,
                            type: 'percent',
                            percentDecimals: 1,
                            percentDecimalsFloating: true
                          },
                          {
                            metricKey: 'new_user_mtx_payer_rate',
                            reqMetricKey: 'new_user_mtx_payer_rate',
                            cnWidth: 245,
                            enWidth: 300,
                            cnPercentWidth: 160,
                            enPercentWidth: 330,
                            resAvgName: '',
                            rainbowKey: 'MTX Payer%(New Users)',
                            enName: 'In-Game Payer%(New Users)',
                            cnName: '内购付费渗透率（新进用户）',
                            avgName: '',
                            isPercent: true,
                            decimal: 1,
                            isUserType: false,
                            type: 'percent',
                            percentDecimals: 1,
                            percentDecimalsFloating: true
                          },
                          {
                            metricKey: 'mtx_new_paid_users',
                            reqMetricKey: 'mtx_new_paid_users',
                            cnWidth: 160,
                            enWidth: 280,
                            cnPercentWidth: 200,
                            enPercentWidth: 280,
                            resAvgName: '',
                            rainbowKey: 'First-time MTX Payer',
                            enName: 'First-time In-Game Payer',
                            cnName: '首次内购用户',
                            type: 'int',
                            avgName: '',
                            isPercent: false,
                            decimals: 1,
                            isUserType: true,
                            percentDecimals: 1,
                            percentDecimalsFloating: true
                          },
                          {
                            metricKey: 'mtx_new_pay_amount',
                            reqMetricKey: 'mtx_new_pay_amount',
                            cnWidth: 170,
                            enWidth: 320,
                            cnPercentWidth: 220,
                            enPercentWidth: 320,
                            resAvgName: '',
                            rainbowKey: 'Rev(First-time MTX Payer)($)',
                            enName: 'Rev(First-time In-Game Payer)($)',
                            cnName: '首次内购收入($)',
                            type: 'decimals',
                            avgName: '',
                            isPercent: false,
                            decimals: 2,
                            isUserType: false,
                            percentDecimals: 1,
                            percentDecimalsFloating: true
                          },
                          {
                            metricKey: 'mtx_new_arpu',
                            reqMetricKey: 'mtx_new_arpu',
                            cnWidth: 230,
                            enWidth: 340,
                            cnPercentWidth: 260,
                            enPercentWidth: 340,
                            resAvgName: '',
                            rainbowKey: 'First-time MTX Payer ARPU',
                            enName: 'First-time In-Game Payer ARPU($)',
                            cnName: '首次内购用户ARPU($)',
                            type: 'decimals',
                            avgName: '',
                            isPercent: false,
                            decimals: 2,
                            isUserType: false,
                            percentDecimals: 1,
                            percentDecimalsFloating: true
                          },
                          {
                            metricKey: 'new_user_arpu',
                            reqMetricKey: 'new_user_arpu',
                            cnWidth: 210,
                            enWidth: 180,
                            cnPercentWidth: 260,
                            enPercentWidth: 210,
                            resAvgName: '',
                            rainbowKey: 'New User ARPU($)',
                            enName: 'New User ARPU($)',
                            cnName: '新进用户付费ARPU($)',
                            type: 'decimals',
                            avgName: '',
                            isPercent: false,
                            decimals: 2,
                            isUserType: false,
                            percentDecimals: 1,
                            percentDecimalsFloating: true
                          }
                        ]
                      }
                    }
                  }
                }
              ]
            }
          ]
        }
      ]
    },
    {
      id: 'inGameBreakdown',
      tabName: 'In-Game Breakdown',
      tabNameCN: '游戏内收入构成',
      isHaveNotification: true,
      notificationPath: '/monetization/revenue/inGameBreakdown',
      path: '/monetization/revenue/inGameBreakdown',
      logConfig: {
        pageId: '202904',
        pageName: 'inGameBreakdown',
        extInfo: 'inGameBreakdown',
        pagePath: '/monetization/revenue/inGameBreakdown'
      },
      filters: [
        {
          name: 'PcConsoleRevenueInGameBreakFilterCo',
          isOpenSticky: true,
          isHaveFilterSave: true,
          filterPath: '/monetization/revenue/inGameBreakdown',
          componentList: [
            {
              name: 'RankListTabCo',
              className: '',
              style: {
                position: 'relative',
                left: '-10px'
              },
              type: 'view',
              data: {
                regionDataType: 'mtx_revenue',
                tabOrder: ['mtx_revenue', 'mtx_arpu', 'mtx_arppu', 'mtx_payers', 'mtx_payer_rate']
              },
              children: [
                {
                  name: 'CommonRow',
                  className: '',
                  type: 'layout',
                  style: {},
                  props: {
                    w: 24
                  },
                  children: [
                    {
                      name: 'CommonCol',
                      className: '',
                      type: 'layout',
                      style: {},
                      props: {
                        w: 24
                      },
                      children: [
                        {
                          name: 'PcConsoleMonetizationRevenueTrendCo',
                          className: '',
                          type: 'view',
                          style: {},
                          props: {
                            config: {
                              api: '/api/v1/dashboard/pc/monetization/revenue/ingame/breakdown',
                              isSegmentFilter: true,
                              dataKey: 'MonetizationBreakdownRankData',
                              breakDownType: 'os'
                            }
                          },
                          children: [
                            {
                              name: 'PcInGameBreakdownCo',
                              className: '',
                              type: 'view',
                              style: {},
                              props: {
                                config: {
                                  config: {},
                                  defaultActive: 0,
                                  isHaveBar: true,
                                  isHaveLine: true,
                                  isHavePie: true,
                                  isHaveShare: true
                                }
                              },
                              children: []
                            }
                          ]
                        }
                      ]
                    },
                    {
                      name: 'CommonCol',
                      className: '',
                      type: 'layout',
                      style: {},
                      props: {
                        w: 24
                      },
                      children: [
                        {
                          name: 'PcConsoleMonetizationRevenueTrendCo',
                          className: '',
                          type: 'view',
                          style: {},
                          props: {
                            config: {
                              api: '/api/v1/dashboard/pc/monetization/revenue/ingame/breakdown',
                              isSegmentFilter: true,
                              dataKey: 'MonetizationBreakdownRankData',
                              breakDownType: 'country'
                            }
                          },
                          children: [
                            {
                              name: 'PcInGameBreakdownCo',
                              className: undefined,
                              style: undefined,
                              type: 'view',
                              props: {
                                config: {
                                  config: {},
                                  defaultActive: 0,
                                  isHaveBar: true,
                                  isHaveLine: true,
                                  isHavePie: true,
                                  isHaveShare: true
                                }
                              }
                            }
                          ]
                        }
                      ]
                    },
                    {
                      name: 'CommonCol',
                      className: '',
                      type: 'layout',
                      style: {},
                      props: {
                        w: 24
                      },
                      children: [
                        {
                          name: 'PcConsoleMonetizationRevenueTrendCo',
                          className: '',
                          type: 'view',
                          style: {},
                          props: {
                            config: {
                              api: '/api/v1/dashboard/pc/monetization/revenue/ingame/breakdown',
                              isSegmentFilter: true,
                              dataKey: 'MonetizationBreakdownRankData',
                              breakDownType: 'region'
                            }
                          },
                          children: [
                            {
                              name: 'PcInGameBreakdownCo',
                              className: undefined,
                              style: undefined,
                              type: 'view',
                              props: {
                                config: {
                                  config: {},
                                  defaultActive: 0,
                                  isHaveBar: true,
                                  isHaveLine: true,
                                  isHavePie: true,
                                  isHaveShare: true
                                }
                              }
                            }
                          ]
                        }
                      ]
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    }
  ]
};
